import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createBlock(_component_Carousel, {
    class: "m-carousel",
    "snap-align": "center",
    autoplay: _ctx.autoPlay ? 5000 : 0,
    "wrap-around": true,
    breakpoints: _ctx.breakpoints
  }, {
    addons: _withCtx(() => [
      _createVNode(_component_Pagination)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], undefined, true),
    _: 3
  }, 8, ["autoplay", "breakpoints"]))
}